export default __webpack_public_path__ + "static/media/me.dbc86c01.jpg";